<h2
  mat-dialog-title
  mat-dialog-draggable-title
  style="margin-bottom: 0px !important"
>
  <div class="row" style="margin: 0">
    <div style="width: 98%;word-break: break-word;">
      <span>{{ "view_pdf.screen_name" | translate }} ({{ data?.name }}) </span>
    </div>
  <div>
    <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  </div>
</h2>
<mat-divider></mat-divider>
<div class="row mt-4">
  <div class="col-12">
    <!-- <iframe
      [src]="src"
      *ngIf="src"
      frameborder="0"
      style="width: 100%; height: 70vh"
    ></iframe> -->
    <ngx-extended-pdf-viewer
      class="pdf-viewer"
      [src]="src"
      useBrowserLocale="true"
      [showDownloadButton]="false"
      [showRotateButton]="false"
      [showOpenFileButton]="false"
      [showBookmarkButton]="false"
      [showPropertiesButton]="false"
      [showUnverifiedSignatures]="true"
      [sidebarVisible]="true"
      [enablePrint]="false"
      [theme]="'dark'"
      [language]="language"
      height="65vh"
      style="display: block"
      [showSecondaryToolbarButton]="false"
    ></ngx-extended-pdf-viewer>
  </div>
</div>

<div mat-dialog-actions class="justify-content-center">
  <!--build icon, set default cancel-->
  <button mat-stroked-button color="primary" [mat-dialog-close]="true">
    <mat-icon class="mr-0">cancel</mat-icon>{{ "button.close" | translate }}
  </button>
  <button class="ml-2" *ngIf="data.element" mat-stroked-button color="primary" type="submit" (click)="downloadTemplate()">
    <mat-icon class="mr-0" style="font-weight: 900">save_alt</mat-icon>
    {{ "enterprise_contract.buttons.download_template" | translate }}
</button>
</div>
